const config = document.querySelector("script[data-loyalty-login-return]");

if (config) {
  const currentUrl = new URL(window.location.href);
  const loginUrl = new URL(config.dataset.loginUrl, currentUrl.origin);
  const registerUrl = new URL(
    config.dataset.registerUrl || "/account/register",
    currentUrl.origin,
  );
  const loyaltyUrl = new URL(config.dataset.loyaltyUrl, currentUrl.origin);
  const normalizePath = (path) => path.replace(/\/+$/, "");
  const matchesPage = (url, page) =>
    url.origin === currentUrl.origin &&
    normalizePath(url.pathname) === normalizePath(page.pathname);

  const sanitizeReturnPath = (value) => {
    if (!value) return "";
    let url;
    try {
      url = new URL(value, currentUrl.origin);
    } catch {
      return "";
    }
    if (url.origin !== currentUrl.origin) return "";
    const path = `${url.pathname}${url.search}${url.hash}`;
    if (!path.startsWith("/") || path.startsWith("//")) return "";
    return path;
  };

  const resolveReturnPath = () => {
    const fromQuery = sanitizeReturnPath(
      currentUrl.searchParams.get("return_to"),
    );
    if (fromQuery) return fromQuery;
    if (document.referrer) {
      try {
        if (matchesPage(new URL(document.referrer), loyaltyUrl)) {
          return loyaltyUrl.pathname;
        }
      } catch {
        return "";
      }
    }
    return "";
  };

  const returnPath = resolveReturnPath();

  const keepReturnTo = () => {
    if (!returnPath) return;
    if (currentUrl.searchParams.get("return_to") === returnPath) return;
    currentUrl.searchParams.set("return_to", returnPath);
    history.replaceState(history.state, "", currentUrl.href);
  };

  const configureAuthForm = (form, formType) => {
    if (!form?.querySelector(`input[name="form_type"][value="${formType}"]`))
      return;
    if (!returnPath) return;

    let returnInput = form.querySelector('input[name="return_to"]');
    if (!returnInput) {
      returnInput = document.createElement("input");
      returnInput.type = "hidden";
      returnInput.name = "return_to";
      form.append(returnInput);
    }
    form
      .querySelectorAll('input[name="return_to"], input[name="checkout_url"]')
      .forEach((input) => {
        input.value = returnPath;
      });

    const action = new URL(form.action, currentUrl.origin);
    action.searchParams.set("return_to", returnPath);
    form.action = action.href;
  };

  const rewriteAuthLink = (link, fromPage, toPage, targetReturn) => {
    if (!(link instanceof HTMLAnchorElement) || !link.hasAttribute("href"))
      return;
    let url;
    try {
      url = new URL(link.href, currentUrl.origin);
    } catch {
      return;
    }
    if (!matchesPage(url, fromPage) && !matchesPage(url, toPage)) return;
    const existingReturn = sanitizeReturnPath(
      url.searchParams.get("return_to"),
    );
    const nextReturn = existingReturn || targetReturn;
    if (!nextReturn) return;
    if (matchesPage(url, toPage) && existingReturn === nextReturn) return;
    const next = new URL(toPage.href);
    next.searchParams.set("return_to", nextReturn);
    link.href = next.href;
  };

  if (matchesPage(currentUrl, loyaltyUrl)) {
    const loyaltyReturn = currentUrl.pathname;
    const updateLink = (link) =>
      rewriteAuthLink(link, registerUrl, loginUrl, loyaltyReturn);
    const updateLinks = (root) => {
      updateLink(root);
      root.querySelectorAll?.("a[href]").forEach(updateLink);
    };
    updateLinks(document);

    // App blocks and mobile navigation can insert login links after page load.
    new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === "attributes") updateLink(record.target);
        else record.addedNodes.forEach(updateLinks);
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["href"],
    });
  } else if (matchesPage(currentUrl, registerUrl) && returnPath) {
    keepReturnTo();

    const configureForm = (form) => configureAuthForm(form, "create_customer");
    document.querySelectorAll("form").forEach(configureForm);
    document.addEventListener(
      "submit",
      (event) => configureForm(event.target),
      true,
    );
    document
      .querySelectorAll("a[href]")
      .forEach((link) =>
        rewriteAuthLink(link, loginUrl, loginUrl, returnPath),
      );
  } else if (matchesPage(currentUrl, loginUrl) && returnPath) {
    keepReturnTo();

    const configureForm = (form) => configureAuthForm(form, "customer_login");
    document.querySelectorAll("form").forEach(configureForm);
    document.addEventListener(
      "submit",
      (event) => configureForm(event.target),
      true,
    );
    document
      .querySelectorAll("a[href]")
      .forEach((link) =>
        rewriteAuthLink(link, registerUrl, registerUrl, returnPath),
      );
  }
}
